import { render, staticRenderFns } from "./Block404.vue?vue&type=template&id=493eb52d&scoped=true"
import script from "./Block404.vue?vue&type=script&lang=js"
export * from "./Block404.vue?vue&type=script&lang=js"
import style0 from "./Block404.vue?vue&type=style&index=0&id=493eb52d&prod&lang=scss&scoped=true"
import style1 from "./Block404.vue?vue&type=style&index=1&id=493eb52d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493eb52d",
  null
  
)

export default component.exports